export const UpdateEntityByFullUid = `
    mutation updateEntityByFullUid ($fullUid: String!, $patchObject: EntityPatch!) {
        updateEntityByFullUid (input: {
            fullUid: $fullUid,
            entityPatch: $patchObject
        }) {
            entity {
                geoType
                fullUid
                name
                membertype
                websiteurl
                notes
                instruc
                datelastchanged
                description
                document
                layerid
            }
        }
    }
`;
